import React from 'react';
import { useReveal } from '../lib/useReveal';
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section id="premium" className="bg-[#ede4d0] py-12 md:py-16 px-4 sm:px-6 border-t border-[#2d3f2a]/5" style={{
    scrollMarginTop: '80px'
  }} data-id="element-61">
      <div className="container mx-auto max-w-5xl" data-id="element-62">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-63">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-2 leading-tight text-[#1e3a1e]" data-id="element-64">
            ELEGÍ TU MEGAPACK
          </h2>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 gap-6 md:gap-8 items-stretch max-w-md mx-auto ${vis2 ? 'is-visible' : ''}`} data-id="element-65">
          {/* Base Card — highlighted offer */}
          <div id="oferta-box" className="relative rounded-3xl flex flex-col text-center bg-[#faf3e3] border-2 border-[#b8860b]/60 shadow-[0_24px_55px_rgba(28,59,54,0.22)] ring-4 ring-[#b8860b]/15 overflow-hidden scroll-mt-24" data-id="element-66">
            {/* Floating badge */}
            <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-[#C2683D] text-white text-[11px] font-bold px-5 py-1.5 rounded-full shadow-md z-20 whitespace-nowrap tracking-[0.18em] uppercase animate-pulse" data-id="element-67">
              ⭐ Oferta por tiempo limitado
            </div>

            {/* Green header band */}
            <div className="bg-[#1C3B36] pt-14 pb-7 px-6 sm:px-9" data-id="element-68">
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-[#F4ECDD] mb-2 leading-tight" data-id="element-69">
                📘 MEGAPACK BIODESCODIFICACIÓN INTEGRAL
              </h3>
              <p className="inline-block bg-[#C2683D] text-white font-bold text-xs sm:text-sm px-4 py-1 rounded-full tracking-wide" data-id="element-70">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="p-6 sm:p-9 flex flex-col" data-id="element-71">
              {/* Includes list */}
              <ul className="space-y-2 mb-6 text-left max-w-xs mx-auto w-full" data-id="element-72">
                {['6 Tomos Profesionales', '6 Bonos Exclusivos', 'Certificado Digital', 'Acceso Inmediato'].map((item, i) => <li key={i} className="flex items-center gap-2.5" data-id="element-73">
                    <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#2E4F48] text-[#F4ECDD] flex items-center justify-center text-[11px] font-bold" data-id="element-74">
                      ✓
                    </span>
                    <span className="text-[#1e3a1e] text-sm font-semibold" data-id="element-75">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="bg-[#E8E0D3] border border-[#b8860b]/25 rounded-xl p-3.5 mb-6 text-center" data-id="element-76">
                <p className="text-[#3a4a35] text-sm leading-snug font-medium" data-id="element-77">
                  <span className="font-bold text-[#1C3B36]" data-id="element-78">Ideal para:</span>{' '}
                  Formarse, comprender el método y empezar a aplicarlo desde el
                  primer día
                </p>
              </div>

              {/* Price block */}
              <div className="flex flex-col items-center justify-center mb-6 pt-5 border-t border-dashed border-[#b8860b]/40" data-id="element-79">
                <span className="text-[#9a8c70] line-through text-lg font-bold" data-id="element-80">
                  $39 USD
                </span>
                <p className="text-5xl sm:text-6xl font-extrabold text-[#1C3B36] leading-none mt-1" data-id="element-81">
                  $15{' '}
                  <span className="text-2xl align-middle text-[#b8860b]" data-id="element-82">
                    USD
                  </span>
                </p>
                <span className="mt-3 inline-block bg-[#C2683D] text-white text-[11px] font-bold rounded-full px-4 py-1.5 tracking-wide uppercase shadow-sm" data-id="element-83">
                  🔥 Ahorrás más del 60%
                </span>
              </div>

              <a id="oferta-cta" href="https://pay.hotmart.com/X106319337N?bid=1781834430846" target="_blank" rel="noopener noreferrer" className="w-full block py-4 rounded-xl text-white font-bold text-sm sm:text-base tracking-widest uppercase text-center transition-all duration-300 bg-[#C2683D] hover:bg-[#A8542F] shadow-[0_12px_28px_rgba(194,104,61,0.4)] hover:shadow-[0_16px_36px_rgba(194,104,61,0.5)] hover:-translate-y-1 mt-auto scroll-mt-32" style={{
              fontFamily: "'Inter', sans-serif",
              letterSpacing: '0.05em'
            }} data-id="element-84">
                → QUIERO MI MEGAPACK
              </a>

              <p className="text-[#44574F] text-xs mt-3 font-semibold" data-id="element-85">
                🔒 Pago seguro · ⚡ Acceso inmediato
              </p>
              <p className="text-[#1C3B36] text-[11px] mt-1.5 font-bold" data-id="element-86">
                💱 Pagás en la moneda de tu país
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}